module.exports = __webpack_public_path__ + "img/temperature_red.ba9a4989.svg";